// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2HpRD","footer":"ReportModalFilter_footer__2619z"};